import React from 'react';
import { connect } from 'react-redux';
import PaymentDetails from './PaymentsDetails';
import Logger, {LOG_LEVELS,ALL_MESSAGES} from '../../utils/logger';

const log = new Logger('MAKING_TAX_DIGITAL_PAYMENTS_PAGE', LOG_LEVELS.DEBUG);

class PaymentsPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pages: -1,
            loading: true,
            pageSize: 1000,
            count: 0,
            page: 1,
        };
    }

    UNSAFE_componentWillMount() {
        log.debug('componentWillMount()');
        log.clearDictionaryError(ALL_MESSAGES.MTD_VAT_NUMBET_NOTAUTH);
    }

    render() {
        log.debug('render(): ', this.props);
        return (
            <div>
                <PaymentDetails data={this.props.paymentsData}
                                pageSizeOptions={[1000, 2000, 5000, 10000]}
                                defaultPageSize={this.state.pageSize}
                />
             <div className="clear"></div>
            </div>
        );
    }
}

PaymentsPage.defaultProps = {
    filterCriteria: {},
    isReportTypeChanged: false
};
// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps', state);
    return {
        languages: state.languages,
        paymentsData: (state.ukMTDVAT && state.ukMTDVAT.payments && state.ukMTDVAT.payments.payments) || [],
        companies: (state.companies && state.companies.data ) || []
    };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(PaymentsPage);